import { useActionsTrack } from "@/_old/features/analytics";
import { Card, CardContent } from "@/core/components/ui/card";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/core/components/ui/tabs";
import { useDashboardFilters } from "@/dashboard/store/useDashboardFilters";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { DashboardRankingsCitiesDataTable } from "./components/cities-data-table";
import { DashboardRankingsSheet } from "./components/dashboard-rankings-sheet";
import { DashboardRankingsGroupsDataTable } from "./components/groups-data-table";
import { DashboardRankingsSpacesDataTable } from "./components/spaces-data-table";
import { Top3Ranking } from "./components/top-3-ranking";
import { DashboardRankingsUsersDataTable } from "./components/users-data-table";

export const DashboardRankings = () => {
  const [translate] = useTranslation(["dashboard"]);
  const { onActionClick } = useActionsTrack();
  const { filters } = useDashboardFilters();
  const [top3RankingData, setTop3RankingData] = useState<
    { position: number; name: string; value: number }[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleRankingsTabChange = useCallback(
    (value: string) => {
      switch (value) {
        case "spaces":
          onActionClick("DASHBOARD_RANKINGS_SPACES_TAB_CLICK", "DASHBOARD");
          break;
        case "cities":
          onActionClick("DASHBOARD_RANKINGS_CITIES_TAB_CLICK", "DASHBOARD");
          break;
        case "users":
          onActionClick("DASHBOARD_RANKINGS_USERS_TAB_CLICK", "DASHBOARD");
          break;
        case "groups":
          onActionClick("DASHBOARD_RANKINGS_GROUPS_TAB_CLICK", "DASHBOARD");
          break;
      }
    },
    [onActionClick],
  );

  return (
    <Tabs defaultValue="spaces" onValueChange={handleRankingsTabChange}>
      <div className="flex flex-col gap-4 py-4">
        <h2 className="text-lg font-medium text-zinc-900">
          {translate("dashboard-rankings-title")}
        </h2>

        <TabsList className="w-full">
          <TabsTrigger value="spaces">
            {translate("dashboard-rankings-spaces-tab")}
          </TabsTrigger>

          <TabsTrigger value="cities">
            {translate("dashboard-rankings-cities-tab")}
          </TabsTrigger>

          <TabsTrigger value="users">
            {translate("dashboard-rankings-users-tab")}
          </TabsTrigger>

          <TabsTrigger value="groups">
            {translate("dashboard-rankings-groups-tab")}
          </TabsTrigger>
        </TabsList>
      </div>

      <Top3Ranking data={top3RankingData} isLoading={isLoading} />

      <Card className="mt-2 border-none">
        <CardContent className="p-4 pt-0">
          <TabsContent value="spaces">
            <DashboardRankingsSpacesDataTable
              filters={filters}
              setTop3RankingData={(data) => setTop3RankingData(data)}
              setIsLoading={(isLoading) => setIsLoading(isLoading)}
            />
          </TabsContent>

          <TabsContent value="cities">
            <DashboardRankingsCitiesDataTable
              filters={filters}
              setTop3RankingData={(data) => setTop3RankingData(data)}
              setIsLoading={(isLoading) => setIsLoading(isLoading)}
            />
          </TabsContent>

          <TabsContent value="users">
            <DashboardRankingsUsersDataTable
              filters={filters}
              setTop3RankingData={(data) => setTop3RankingData(data)}
              setIsLoading={(isLoading) => setIsLoading(isLoading)}
            />
          </TabsContent>

          <TabsContent value="groups">
            <DashboardRankingsGroupsDataTable
              filters={filters}
              setTop3RankingData={(data) => setTop3RankingData(data)}
              setIsLoading={(isLoading) => setIsLoading(isLoading)}
            />
          </TabsContent>

          <div className="flex justify-end p-4 pb-0 w-full">
            <DashboardRankingsSheet />
          </div>
        </CardContent>
      </Card>
    </Tabs>
  );
};
